module.exports = __webpack_public_path__ + "img/tuiguang2-2.d08b0686.png";